import type { AxiosInstance } from "axios";
import { apiClient } from "@/data/axiosConfig";

export interface VehicleSearchRequest {
  licencePlate: string;
}

export interface VehicleSearchResponse {
  result: VehicleResult | null;
}

export interface VehicleResult {
  vin: string;
  make: string;
  model: string;
  cylinderCapacity: string;
  numberOfDoors: string;
  yearOfManufacture: string;
  fuelType: string;
  colour: string;
  taxed: boolean;
  mot: boolean;
}

export function createVehicleSearchApi(client: AxiosInstance) {
  return {
    search: async (request: VehicleSearchRequest): Promise<VehicleSearchResponse> => {
      const response = await client.post<VehicleSearchResponse>("/api/vehicle-search", request);
      return response.data;
    },
  };
}

export const vehicleSearchApi = createVehicleSearchApi(apiClient);

